import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import {
  LandingNav, Hero, AudienceGrid, FeaturesSection, PricingPreview, CtaSection, LandingFooter,
} from "@/components/landing/sections";

export default function Landing() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [plans, setPlans] = useState(null);
  const [cycle, setCycle] = useState("monthly");

  const loadConfig = useCallback(() => {
    api.get("/config").then(({ data }) => setPlans(data.plans)).catch(() => {});
  }, []);

  useEffect(() => { loadConfig(); }, [loadConfig]);

  const go = useCallback(() => navigate(user ? "/dashboard" : "/register"), [navigate, user]);

  return (
    <div className="min-h-screen bg-[#F8F9FA]">
      <LandingNav user={user} />
      <Hero onStart={go} />
      <AudienceGrid />
      <FeaturesSection />
      <PricingPreview plans={plans} cycle={cycle} setCycle={setCycle} onSelect={go} />
      <CtaSection onStart={go} />
      <LandingFooter />
    </div>
  );
}
